<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'artistAddPage',
})
</script>
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="main artist-detail-page">
    <a-card>
      <a-spin :spinning="state.loading.init">
        <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules" class="artist-form"
          :wrapper-col="{ style: 'flex: 1' }">
          <section class="artist-base-panel">
            <div class="artist-cover-column">
              <a-form-item label="封面" name="cover" class="cover-form-item">
                <div class="cover-upload-wrap">
                  <a-upload v-if="!state.loading.init" v-model:file-list="fileList" :max-count="1" accept="image/*"
                    list-type="picture-card" :before-upload="beforeUpload" :disabled="uploadLoading"
                    @change="handleUploadChange" @preview="handlePreview"
                    :show-upload-list="{ showPreviewIcon: true, showRemoveIcon: true }">
                    <template #itemRender="{ originNode, file, actions: { preview, remove } }">
                      <template v-if="file.status === 'uploading'">
                        <VNodeRender :vnode="originNode" />
                      </template>
                      <div v-else class="ant-upload-list-item-container">
                        <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-image">
                          <div class="ant-upload-list-item-thumbnail">
                            <img v-if="isValidImageUrl(file.url || file.thumbUrl)" :src="file.url || file.thumbUrl"
                              :alt="file.name" />
                            <div v-else class="cover-error">
                              <PictureOutlined />
                            </div>
                          </div>
                          <span class="ant-upload-list-item-actions">
                            <a v-if="isValidImageUrl(file.url || file.thumbUrl)" class="ant-upload-list-item-action"
                              title="查看" @click.stop="preview()">
                              <EyeOutlined />
                            </a>
                            <a v-if="isValidImageUrl(file.url || file.thumbUrl)" class="ant-upload-list-item-action"
                              :href="file.url || file.thumbUrl" :download="file.name" title="下载">
                              <DownloadOutlined />
                            </a>
                            <a class="ant-upload-list-item-action" title="删除" @click.stop="remove()">
                              <DeleteOutlined />
                            </a>
                          </span>
                        </div>
                      </div>
                    </template>
                    <div v-if="showUploadTrigger" class="upload-trigger-content">
                      <template v-if="uploadLoading">
                        <div class="manual-progress">
                          <div class="manual-progress-track">
                            <div class="manual-progress-bar"
                              :style="{ width: uploadProgress < 100 ? `${uploadProgress}%` : '100%' }"></div>
                          </div>
                          <div class="manual-progress-text">{{ uploadProgress < 100 ? `上传中 ${uploadProgress}%`
                            : '处理中...' }}</div>
                          </div>
                      </template>
                      <template v-else>
                        <PlusOutlined />
                        <div class="ant-upload-text">上传封面</div>
                      </template>
                    </div>
                  </a-upload>
                </div>

                <a-image-preview-group ref="previewGroupRef" :preview="{
                  visible: previewVisible,
                  current: previewCurrent,
                  wrapClassName: 'artist-cover-preview',
                  onVisibleChange: (v: boolean) => (previewVisible = v),
                  onChange: (c: number) => (previewCurrent = c)
                }" class="preview-group">
                  <a-image v-for="(url, index) in coverImageList" :key="index" :src="url" :alt="`图片${index + 1}`"
                    :style="{ display: 'none' }" />
                </a-image-preview-group>
              </a-form-item>
            </div>

            <div class="artist-fields-column">
              <a-form-item label="当前展览展示" name="currentExhibition" class="exhibition-form-item">
                <a-switch class="artist-exhibition-switch" :checked="state.ruleForm.currentExhibition === 1"
                  checked-children="是" un-checked-children="否"
                  @change="(checked: boolean) => (state.ruleForm.currentExhibition = checked ? 1 : 0)" />
              </a-form-item>
              <a-form-item label="艺术家" name="name">
                <a-input v-model:value="state.ruleForm.name" placeholder="请输入艺术家姓名" :maxlength="20" show-count
                  allow-clear />
              </a-form-item>
              <a-form-item label="副文本" name="subText" class="sub-text-form-item">
                <a-textarea v-model:value="state.ruleForm.subText" placeholder="请输入副文本" :maxlength="50" :rows="4"
                  show-count allow-clear />
              </a-form-item>
            </div>
          </section>

          <section class="artist-content-panel">
            <a-tabs v-model:activeKey="activeTab" class="artist-content-tabs">
              <a-tab-pane key="intro" tab="简介">
                <a-form-item class="editor-form-item">
                  <WangEditor v-model:get-html="state.ruleForm.introContent" height="380px" placeholder="请输入艺术家简介"
                    normalize-blank-lines />
                </a-form-item>
              </a-tab-pane>
              <a-tab-pane key="works" tab="作品">
                <a-form-item class="editor-form-item">
                  <WangEditor v-model:get-html="state.ruleForm.worksContent" height="380px" placeholder="请输入艺术家作品"
                    normalize-blank-lines />
                </a-form-item>
              </a-tab-pane>
            </a-tabs>

            <div class="detail-footer">
              <a-button class="detail-close-btn" @click="onCancel">取 消</a-button>
              <a-button v-if="!isPublished" class="detail-confirm-btn" :loading="state.loading.saveDraft"
                @click="onSaveDraft">保存草稿</a-button>
              <a-button class="detail-publish-btn" type="primary" :loading="state.loading.publish"
                @click="onPublish">发布</a-button>
            </div>
          </section>
        </a-form>
      </a-spin>
    </a-card>

    <ImageCropper v-model:visible="cropperVisible" :image-url="cropperImageUrl" :output-type="cropperOutputType"
      :crop-width="375" :crop-height="375" @confirm="handleCropConfirm" @cancel="handleCropCancel" />
  </div>
</template>

<script setup lang="ts" name="artistAddPage">
import { computed, h, nextTick, onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { DeleteOutlined, DownloadOutlined, ExclamationCircleOutlined, EyeOutlined, PictureOutlined, PlusOutlined } from '@ant-design/icons-vue'
import { useArtist, type ArtistSavePayload } from '@/store/artist/artist'
import WangEditor from '@/components/editor/index.vue'
import ImageCropper from '@/components/ImageCropper/index.vue'
import baseService from '@/utils/http/axios'
import storage from '@/utils/Storage'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { makeImagesResponsive } from './artistContent'

const route = useRoute()
const router = useRouter()
const artistStore = useArtist()
const artistId = computed(() => (route.params.id ? String(route.params.id) : ''))
const isEdit = computed(() => Boolean(artistId.value))
const isPublished = computed(() => isEdit.value && state.status === 1)

const formRef = ref()
const activeTab = ref('intro')
const fileList = ref<any[]>([])
const previewVisible = ref(false)
const previewGroupRef = ref()
const previewCurrent = ref(0)
const cropperVisible = ref(false)
const cropperImageUrl = ref('')
const cropperOutputType = ref<string>('png')
const uploadLoading = ref(false)
const uploadProgress = ref(0)
let pendingFile: File | null = null

const state = reactive({
  loading: {
    // 编辑页首次渲染即进入加载态，避免详情回显前闪现“上传封面”
    init: isEdit.value,
    saveDraft: false,
    publish: false
  },
  status: 0,
  ruleForm: {
    id: '',
    cover: '',
    name: '',
    subText: '',
    introContent: '',
    worksContent: '',
    currentExhibition: 0 as 0 | 1
  },
  rules: {
    cover: [{ required: true, message: '请上传封面', trigger: ['change', 'blur'] }],
    name: [
      { required: true, message: '请输入艺术家姓名', trigger: 'blur' },
      { max: 20, message: '艺术家姓名不能超过20个字', trigger: 'blur' }
    ],
    subText: [
      { required: true, message: '请输入副文本', trigger: 'blur' },
      { max: 50, message: '副文本不能超过50个字', trigger: 'blur' }
    ],
    currentExhibition: [{ required: true, message: '请选择当前展览展示', trigger: 'change' }]
  }
})

const coverImageList = computed(() => {
  if (!state.ruleForm.cover) return []
  return isValidImageUrl(state.ruleForm.cover) ? [state.ruleForm.cover] : []
})

// 同时根据详情加载、封面字段和文件列表决定是否显示上传入口，避免删除过程的中间态抖动
const showUploadTrigger = computed(() => {
  return !state.loading.init && !state.ruleForm.cover && fileList.value.length < 1
})

const VNodeRender = (props: { vnode: any }) => props.vnode

const uploadHeaders = { Authorization: storage.get(ACCESS_TOKEN) || '' }

const uploadCover = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  uploadLoading.value = true
  uploadProgress.value = 0
  // 上传期间清空 fileList，让 trigger slot 显示进度条
  fileList.value = []
  try {
    const res: any = await baseService({
      url: '/console/file/uploadFile',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...uploadHeaders
      },
      onUploadProgress: (progressEvent: any) => {
        const percent = progressEvent.total ? Math.round((progressEvent.loaded * 100) / progressEvent.total) : 0
        uploadProgress.value = percent
      }
    })
    const url = typeof res.data === 'string' ? res.data : res.data?.url
    if (url) {
      fileList.value = [
        {
          uid: `-${Date.now()}`,
          name: file.name,
          status: 'done',
          url,
          thumbUrl: url
        }
      ]
      state.ruleForm.cover = url
      // 清除表单封面字段的校验错误
      nextTick(() => {
        formRef.value?.clearValidate('cover')
        formRef.value?.validateFields(['cover']).catch(() => { })
      })
    } else {
      message.error('上传失败')
    }
  } catch (e) {
    message.error('上传失败')
  } finally {
    uploadLoading.value = false
    uploadProgress.value = 0
  }
}

const beforeUpload = (file: File) => {
  const isImage = file.type.startsWith('image/')
  const isLt10M = file.size / 1024 / 1024 < 10
  if (!isImage) {
    message.error('只能上传图片文件')
    return false
  }
  if (!isLt10M) {
    message.error('图片大小不能超过10MB')
    return false
  }
  pendingFile = file
  // 清空 fileList，避免 Ant Upload 把未裁剪文件加入列表
  fileList.value = []
  // 根据原图类型设置裁剪输出格式
  cropperOutputType.value = file.type === 'image/jpeg' || file.type === 'image/jpg' ? 'jpeg' : 'png'
  const reader = new FileReader()
  reader.onload = (e) => {
    cropperImageUrl.value = e.target?.result as string
    cropperVisible.value = true
  }
  reader.readAsDataURL(file)
  return false
}

const handleCropConfirm = async (file: File) => {
  if (pendingFile) {
    await uploadCover(file)
    pendingFile = null
  }
}

const handleCropCancel = () => {
  pendingFile = null
  cropperImageUrl.value = ''
  // 取消裁剪时：如果之前有已上传成功的封面，保留；否则清空
  const doneFiles = fileList.value.filter((f: any) => f.status === 'done' && f.url)
  if (doneFiles.length > 0) {
    fileList.value = doneFiles
  } else {
    fileList.value = []
    state.ruleForm.cover = ''
  }
}

const handleUploadChange = ({ fileList: list }: any) => {
  // 手动维护 fileList，删除时同步清空 cover 并触发校验
  if (list.length === 0) {
    fileList.value = []
    state.ruleForm.cover = ''
    nextTick(() => {
      formRef.value?.validateFields(['cover']).catch(() => { })
    })
  }
}

const handlePreview = () => {
  previewCurrent.value = 0
  previewVisible.value = true
}

const isValidImageUrl = (url: string) => {
  if (!url) return false
  return /^https?:\/\//i.test(url)
}

const buildPayload = (publish: boolean): ArtistSavePayload => ({
  id: isEdit.value ? artistId.value : undefined,
  cover: state.ruleForm.cover,
  name: state.ruleForm.name,
  subText: state.ruleForm.subText,
  introContent: makeImagesResponsive(state.ruleForm.introContent || ''),
  worksContent: makeImagesResponsive(state.ruleForm.worksContent || ''),
  currentExhibition: state.ruleForm.currentExhibition,
  publish
})

const save = async (publish: boolean) => {
  const loadingKey = publish ? 'publish' : 'saveDraft'
  state.loading[loadingKey] = true
  try {
    await artistStore.saveArtist(buildPayload(publish))
    message.success(publish ? '发布成功' : '保存草稿成功')
    router.push({ name: 'artist' })
  } finally {
    state.loading[loadingKey] = false
  }
}

const onSaveDraft = () => save(false)

const onPublish = async () => {
  try {
    await formRef.value?.validate()
  } catch (error) {
    message.error('请完善必填信息')
    return
  }
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: '发布后艺术家信息将对用户可见，是否确认发布？',
    okText: '确认',
    cancelText: '取消',
    onOk: () => save(true)
  })
}

const onCancel = () => {
  router.push({ name: 'artist' })
}

const loadEditDetail = async () => {
  if (!isEdit.value) return
  state.loading.init = true
  try {
    const record = await artistStore.getArtistInfo(artistId.value)
    state.ruleForm.id = artistId.value
    state.ruleForm.cover = record.cover || ''
    state.ruleForm.name = record.name || ''
    state.ruleForm.subText = record.subText || ''
    state.ruleForm.introContent = record.introContent || ''
    state.ruleForm.worksContent = record.worksContent || ''
    state.ruleForm.currentExhibition = record.currentExhibition === 1 ? 1 : 0
    state.status = record.status
    if (record.cover) {
      fileList.value = [
        {
          uid: '-1',
          name: record.cover.split('/').pop() || 'cover',
          status: 'done',
          url: record.cover,
          thumbUrl: record.cover
        }
      ]
    }
  } catch (error) {
    message.error('艺术家详情数据读取失败')
    router.replace({ name: 'artist' })
  } finally {
    state.loading.init = false
  }
}

onMounted(loadEditDetail)
</script>

<style scoped lang="less">
@import '@/style/index.less';

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.artist-fields-column .ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #c5c5d3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.artist-fields-column textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #c5c5d3;
}

.artist-detail-page {
  :deep(.ant-card) {
    border: none;
    background: transparent;
  }

  :deep(.ant-card-body) {
    padding: 0;
  }
}

.artist-form {
  --artist-label-width: 54px;

  :deep(.ant-form-item-label) {
    width: var(--artist-label-width);
    margin-right: 10px;
    text-align: right;
  }

  :deep(.ant-input-affix-wrapper),
  :deep(.ant-input) {
    border-radius: 4px;
  }

  :deep(.ant-input-affix-wrapper) {
    height: 40px;
    min-height: 40px;
    padding: 0 11px;
    display: flex;
    align-items: center;
  }
}

.artist-base-panel {
  display: grid;
  grid-template-columns: minmax(280px, 36%) minmax(420px, 1fr);
  gap: 72px;
  min-height: 300px;
  padding: 36px 36px;
  background: #fff;
  border-radius: 8px;
}

.artist-cover-column {
  display: flex;
  align-items: flex-start;
}

.artist-fields-column {
  // 右侧需要容纳“当前展览展示”，封面列仍使用表单默认的 54px 标签宽度
  --artist-label-width: 108px;
  max-width: 560px;

  :deep(.ant-form-item) {
    margin-bottom: 20px;
  }

  :deep(.ant-form-item-row) {
    align-items: flex-start;
  }

  :deep(.ant-form-item-label) {
    flex: 0 0 var(--artist-label-width);
    width: var(--artist-label-width);
    max-width: var(--artist-label-width);
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  :deep(.ant-form-item-label > label) {
    width: 100%;
    justify-content: flex-end;
    text-align: right;
  }

  :deep(textarea.ant-input) {
    height: 130px;
    min-height: 130px;
    max-height: 130px;
    padding: 8px 28px 8px 11px;
    resize: none;
  }

  // textarea 的外层不固定为单行输入框高度
  :deep(.ant-input-affix-wrapper:has(textarea)) {
    height: auto !important;
    min-height: 130px;
    padding: 0;
  }

  // 计数文字放在右下角，避免与右上角的清除按钮重叠
  :deep(.sub-text-form-item .ant-input-textarea) {
    position: relative;
    display: inline-block;
    width: 100%;

    &[data-count]::after {
      content: attr(data-count);
      position: absolute;
      right: 10px;
      bottom: 5px;
      z-index: 1;
      padding-left: 4px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
      line-height: 1;
      background: #fff;
      pointer-events: none;
    }
  }

  :deep(.sub-text-form-item .ant-input-data-count) {
    display: none;
  }

  :deep(.sub-text-form-item .ant-input-clear-icon) {
    position: absolute;
    top: 12px;
    right: 10px;
    bottom: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    margin-top: 0;
    line-height: 1;
  }
}

.exhibition-form-item {
  :deep(.ant-form-item-control-input) {
    display: flex;
    align-items: center;
    min-height: 40px;
  }
}

:deep(.artist-exhibition-switch.ant-switch-checked) {
  background-color: #0f813d;
}

:deep(.artist-exhibition-switch.ant-switch-checked:hover:not(.ant-switch-disabled)) {
  background-color: #0a6b31;
}

.cover-form-item {

  // 禁用 picture-card 的移除离场动画，避免旧图占据第一格时上传入口短暂出现在第二格
  :deep(.ant-upload-animate-inline-leave),
  :deep(.ant-upload-animate-inline-leave-active),
  :deep(.ant-upload-animate-inline-leave-to) {
    display: none !important;
    animation: none !important;
  }

  :deep(.ant-upload-list-item-container) {
    transition: none !important;
  }

  :deep(.ant-form-item-row) {
    align-items: flex-start;
  }

  :deep(.ant-form-item-label) {
    padding-top: 0;
    height: auto;
    align-items: flex-start;
  }

  .ant-upload-list-item-container {
    :deep(.ant-upload-list-item) {
      width: 100%;
      height: 100%;
      padding: 0 !important;
      border: 1px dashed #c5c5d3;

      &.ant-upload-list-item-done {
        position: relative;

        &::before {
          position: absolute;
          inset: 0;
          width: 100% !important;
          height: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
        }
      }

      .ant-upload-list-item-thumbnail {
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .ant-upload-list-item-actions {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.45);
        opacity: 0;
        transition: opacity 0.2s;

        .ant-upload-list-item-action {
          color: #fff;
          background: transparent;
        }
      }

      &:hover .ant-upload-list-item-actions {
        opacity: 1;
      }
    }

    .ant-upload-list-item-thumbnail-file {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: rgba(0, 0, 0, 0.45);
      background: #fafafa;
    }

    .upload-item-name {
      display: block;
      max-width: 88px;
      padding: 4px 8px;
      overflow: hidden;
      font-size: 11px;
      line-height: 1.3;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }

  :deep(.ant-upload-list-picture-card .ant-upload-list-item-container),
  :deep(.ant-upload-list-picture-card .ant-upload-list-picture-card-container),
  :deep(.ant-upload-select-picture-card) {
    width: 130px !important;
    height: 130px !important;
    min-width: 130px !important;
    min-height: 130px !important;
    margin: 0;
  }

  :deep(.ant-upload-list-picture-card) {
    display: flex;
    align-items: center;
  }

  :deep(.ant-upload-list-item) {
    padding: 0 !important;
    border: 1px dashed #c5c5d3;
  }

  :deep(.ant-upload-list-item-thumbnail) {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  :deep(.ant-upload-list-item-actions) {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    transition: opacity 0.2s;

    .ant-upload-list-item-action {
      color: #fff;
      background: transparent;
    }
  }

  :deep(.ant-upload-list-item):hover .ant-upload-list-item-actions {
    opacity: 1;
  }

  .cover-upload-wrap {
    position: relative;
    display: inline-flex;
    width: 130px;
    height: 130px;
    vertical-align: top;

    :deep(.ant-upload.ant-upload-select-picture-card),
    :deep(.ant-upload-select),
    :deep(.ant-upload-select-picture-card) {
      width: 130px !important;
      height: 130px !important;
      min-width: 130px !important;
      min-height: 130px !important;
      margin: 0 !important;
    }
  }

  .upload-trigger-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .manual-progress {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 0 8px;
    box-sizing: border-box;

    .manual-progress-track {
      width: 100%;
      height: 4px;
      background: rgba(0, 0, 0, 0.08);
      border-radius: 2px;
      overflow: hidden;
    }

    .manual-progress-bar {
      height: 100%;
      background: #0f813d;
      border-radius: 2px;
      transition: width 0.1s linear;
    }

    .manual-progress-text {
      font-size: 11px;
      color: #666;
      line-height: 1;
      white-space: nowrap;
    }
  }
}

.cover-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #0b0b0b;
  background: #f5f5f5;
  font-size: 28px;

  :deep(svg),
  :deep(.anticon) {
    color: #0b0b0b !important;
    fill: #0b0b0b !important;
  }
}

.artist-content-panel {
  margin-top: 20px;
  background: transparent;
}

.artist-content-tabs {
  :deep(.ant-tabs-nav) {
    margin: 0;
    background: transparent;

    &::before {
      display: none;
    }
  }

  :deep(.ant-tabs-tab) {
    height: 40px;
    min-width: 130px;
    margin: 0;
    padding: 0 28px;
    justify-content: center;
    color: #757070;
    background: #f7f7f7;
    border-radius: 12px 12px 0 0;

    .ant-tabs-tab-btn {
      color: #757070;
      font-family: 'SourceHanSansCN-Regular', 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
    }
  }

  :deep(.ant-tabs-tab-active) {
    background: #fff;
    border-radius: 12px 12px 0 0;

    .ant-tabs-tab-btn {
      color: #0b0b0b;
      font-weight: 400;
    }
  }

  :deep(.ant-tabs-ink-bar) {
    display: none;
  }

  :deep(.ant-tabs-content-holder) {
    padding: 38px 38px 18px;
    background: #fff;
  }
}

.editor-form-item {
  margin-bottom: 0;

  :deep(.ant-form-item-control) {
    width: 100%;
  }
}

.detail-footer {
  display: flex;
  justify-content: center;
  padding: 12px 0 30px;
  background: #fff;
  border-radius: 0 0 8px 8px;

  .detail-close-btn,
  .detail-confirm-btn,
  .detail-publish-btn {
    width: 120px;
    height: 40px;
    border-radius: 20px !important;
    font-size: 16px;
  }

  .detail-close-btn,
  .detail-confirm-btn {
    color: #0b0b0b;
    background: #fff;
    border: 1px solid #0b0b0b;

    &:hover:not(:disabled) {
      color: #0b0b0b;
      background: #fff;
      border-color: #0b0b0b;
    }
  }

  .detail-confirm-btn,
  .detail-publish-btn {
    margin-left: 10px;
  }

  .detail-publish-btn {
    color: #fff;
    background: #0b0b0b;
    border-color: #0b0b0b;

    &:hover:not(:disabled) {
      color: #fff;
      background: #0b0b0b;
      border-color: #0b0b0b;
    }
  }
}

@media (max-width: 1200px) {
  .artist-base-panel {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .artist-fields-column {
    max-width: none;
  }
}
</style>

<style lang="less">
.artist-cover-preview .ant-image-preview-img {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
}
</style>
